import { render, staticRenderFns } from "./CommentModalEdit.vue?vue&type=template&id=6ea04bc2&"
import script from "./CommentModalEdit.vue?vue&type=script&lang=js&"
export * from "./CommentModalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports